import type { PutAway, TargetCapabilities } from "../net/api.ts";

export const NOTHING_PUT_AWAY: PutAway = {
  snoozedUntil: null,
  archivedForMe: false,
  archivedForAll: false,
  pinnedForMe: false,
  pinnedForAll: false,
};

export const ALL_TARGET_CAPABILITIES: TargetCapabilities = {
  react: true,
  reply: true,
  snooze: true,
  pin: true,
  archive: true,
  collective: false,
};

export type TargetAction = "react" | "reply" | "snooze" | "pin" | "archive";

export function actionPresentation(input: {
  coarse: boolean;
  rowHovered: boolean;
  rowFocused: boolean;
  chipHovered: boolean;
  chipFocused: boolean;
}): { rowOpacity: number; strong: boolean } {
  const revealed = input.coarse || input.rowHovered || input.rowFocused;
  return {
    rowOpacity: revealed ? 1 : 0.28,
    strong: input.chipHovered || input.chipFocused,
  };
}

export function actionsFor(reply: boolean, reaction: boolean): TargetAction[] {
  return [
    ...(reaction ? (["react"] as const) : []),
    ...(reply ? (["reply"] as const) : []),
    "snooze",
    "pin",
    "archive",
  ];
}

export function undoScope(mine: boolean, all: boolean): "me" | "all" | null {
  if (mine) return "me";
  if (all) return "all";
  return null;
}
